var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90546 1.96152C5.07059 1.96152 1.96182 5.06967 1.96182 8.90376C1.96182 12.7379 5.07059 15.846 8.90546 15.846C12.7403 15.846 15.8491 12.7379 15.8491 8.90376C15.8491 5.06967 12.7403 1.96152 8.90546 1.96152ZM0.5 8.90376C0.5 4.26249 4.26325 0.5 8.90546 0.5C13.5477 0.5 17.3109 4.26249 17.3109 8.90376C17.3109 13.545 13.5477 17.3075 8.90546 17.3075C4.26325 17.3075 0.5 13.545 0.5 8.90376Z",
    fill: "#12428A",
    stroke: "#12428A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8117 13.8127C14.0972 13.5273 14.56 13.5273 14.8454 13.8127L19.2857 18.2521C19.5712 18.5375 19.5712 19.0002 19.2857 19.2856C19.0003 19.5709 18.5375 19.5709 18.2521 19.2856L13.8117 14.8461C13.5263 14.5607 13.5263 14.098 13.8117 13.8127Z",
    fill: "#12428A",
    stroke: "#12428A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlass);
export default __webpack_public_path__ + "static/media/search_glass.f2b07099.svg";
export { ForwardRef as ReactComponent };